"use client"
import { ComponentConfig } from "@measured/puck"
import { Button, Input } from "antd"
import { useState } from "react"
import "./styles.module.css"

export interface FindInputProps {
  placeholder?: string
  buttonText?: string
  onClick?: (inputValue: string) => void
}

export const RenderConfig: ComponentConfig<FindInputProps> = {
  render: ({ placeholder, buttonText, onClick }: FindInputProps) => {
    const [inputValue, setInputValue] = useState("")

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      setInputValue(e.target.value)
    }

    const handleClick = () => {
      if (onClick) {
        onClick(inputValue)
      }
    }

    return (
      <div
        id="section-input"
        className="flex justify-center h-full w-full min-h-[42px] max-w-[50%] mx-auto py-7 text-4"
      >
        <Input
          id="input"
          className="border-2 border-[#cdcdcd] w-[75%] pl-[2rem] rounded-[50px] text-black h-[44px] hover:border-[#cdcdcd"
          placeholder={placeholder}
          value={inputValue}
          onChange={handleInputChange}
        />
        <Button
          className="text-white w-[20%] min-h-[2rem] relative rounded-[50px] border-white border-2 box-content py-[4px] px-[6px]"
          type="primary"
          style={{ background: "linear-gradient(to right top, #5bb97a, #298cca)" }}
          onClick={handleClick}
        >
          {buttonText}
        </Button>
      </div>
    )
  },
}
